"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVITY_SCENE_ID_DELIMITER = void 0;
exports.buildActivitySceneId = buildActivitySceneId;
exports.resolveActivitySceneId = resolveActivitySceneId;
exports.matchesActivityGroupFilter = matchesActivityGroupFilter;
exports.sortActivitiesForGroup = sortActivitiesForGroup;
exports.getOrderedEligibleActivities = getOrderedEligibleActivities;
exports.getActivitySceneForCharacter = getActivitySceneForCharacter;
exports.getFirstActivitySceneInGroup = getFirstActivitySceneInGroup;
exports.getNextActivitySceneInGroup = getNextActivitySceneInGroup;
const incompleteActivityChecks_1 = require("./incompleteActivityChecks");
const evaluateActivityPlayable_1 = require("./evaluateActivityPlayable");
/** Delimiter between {@link ActivityDefinition.scenePrefix} and a scene postfix (e.g. {@code points}). */
exports.ACTIVITY_SCENE_ID_DELIMITER = '-';
function buildActivitySceneId(scenePrefix, scenePostfix) {
    const prefix = (scenePrefix ?? '').trim();
    const postfix = (scenePostfix ?? '').trim();
    if (!prefix || !postfix) {
        return '';
    }
    return `${prefix}${exports.ACTIVITY_SCENE_ID_DELIMITER}${postfix}`;
}
function resolveActivitySceneId(def, scenePostfix) {
    if (!def) {
        return '';
    }
    const prefix = (def.scenePrefix ?? '').trim();
    if (!prefix) {
        return '';
    }
    return buildActivitySceneId(prefix, scenePostfix);
}
function matchesActivityGroupFilter(def, filter) {
    const types = (0, incompleteActivityChecks_1.parseActivityIdsCsv)(filter.typesCsv ?? '');
    const exclude = new Set((0, incompleteActivityChecks_1.parseActivityIdsCsv)(filter.excludeIdsCsv ?? ''));
    if (types.length > 0 && !types.includes(def.typeId)) {
        return false;
    }
    if (exclude.has(def.id)) {
        return false;
    }
    const parentSpecified = filter.parentActivityId !== undefined;
    if (parentSpecified) {
        const parentRaw = (filter.parentActivityId ?? '').toString().trim();
        const parent = (def.parentActivityId ?? '').trim();
        if (parentRaw === '') {
            return parent === '';
        }
        return parent === parentRaw;
    }
    return true;
}
function sortActivitiesForGroup(activities, sort = 'list_order') {
    return [...activities].sort((a, b) => {
        if (sort === 'name') {
            return a.name.localeCompare(b.name);
        }
        if (a.listOrder !== b.listOrder) {
            return a.listOrder - b.listOrder;
        }
        return a.id.localeCompare(b.id);
    });
}
/**
 * Activities matching {@link ActivityGroupFilter} and visible for {@code characterName},
 * sorted by {@code filter.sort} (default {@code list_order}).
 */
function getOrderedEligibleActivities(activities, characterName, filter) {
    const candidates = activities.filter((def) => matchesActivityGroupFilter(def, filter) &&
        (0, evaluateActivityPlayable_1.evaluateActivityVisibleForCharacter)(def, characterName));
    return sortActivitiesForGroup(candidates, filter.sort === 'name' ? 'name' : 'list_order');
}
function getActivitySceneForCharacter(ctx, activityId, scenePostfix) {
    const def = ctx.activities.find((a) => a.id === activityId);
    const sceneId = resolveActivitySceneId(def, scenePostfix);
    if (!sceneId || !ctx.validSceneIds.has(sceneId)) {
        return '';
    }
    return sceneId;
}
function getFirstActivitySceneInGroup(ctx, scenePostfix) {
    const ordered = getOrderedEligibleActivities(ctx.activities, ctx.characterName, ctx.filter);
    for (const def of ordered) {
        const sceneId = resolveActivitySceneId(def, scenePostfix);
        if (sceneId && ctx.validSceneIds.has(sceneId)) {
            return sceneId;
        }
    }
    return '';
}
function getNextActivitySceneInGroup(ctx, currentActivityId, scenePostfix, terminalSceneId) {
    const terminal = (terminalSceneId ?? '').trim();
    const ordered = getOrderedEligibleActivities(ctx.activities, ctx.characterName, ctx.filter);
    const current = (currentActivityId ?? '').trim();
    const idx = ordered.findIndex((d) => d.id === current);
    if (idx === -1) {
        if (terminal && ctx.validSceneIds.has(terminal)) {
            return terminal;
        }
        const first = getFirstActivitySceneInGroup(ctx, scenePostfix);
        if (first) {
            return first;
        }
        return '';
    }
    for (let i = idx + 1; i < ordered.length; i++) {
        const sceneId = resolveActivitySceneId(ordered[i], scenePostfix);
        if (sceneId && ctx.validSceneIds.has(sceneId)) {
            return sceneId;
        }
    }
    if (terminal && ctx.validSceneIds.has(terminal)) {
        return terminal;
    }
    return '';
}
//# sourceMappingURL=activitySceneHelpers.js.map